// src/components/Modals/ConfirmDeleteModal.tsx
import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import DotLoader from "../../components/Loader/DotLoader";

const style = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

interface ConfirmDeleteModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
  open,
  onClose,
  onConfirm,
  loading,
}) => (
  <Modal open={open} onClose={onClose}>
    <Box sx={style}>
      <Box display="flex" alignItems="center" mb={2}>
        <WarningAmberIcon sx={{ color: "#f87171", mr: 1 }} />
        <Typography variant="h6" fontWeight="bold">
          Are you sure?
        </Typography>
      </Box>
      <Typography mb={3} color="textSecondary">
        This action cannot be undone. If you are looking to edit the
        information, you can use the edit button instead.
      </Typography>
      <Box display="flex" justifyContent="flex-end" gap={1}>
        {loading ? (
          <Button
            variant="contained"
            disabled
            style={{
              backgroundColor: "transparent",
              height: "36px",
              minWidth: "100px",
            }}
          >
            <DotLoader color="#ef4444" />
          </Button>
        ) : (
          <>
            <Button variant="outlined" onClick={onClose}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={onConfirm}
              disabled={loading}
              sx={{
                backgroundColor: "#ef4444",
                "&:hover": {
                  backgroundColor: "#dc2626",
                },
              }}
            >
              Delete
            </Button>
          </>
        )}
      </Box>
    </Box>
  </Modal>
);

export default ConfirmDeleteModal;
